module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "joke-card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.removeJoke(_vm.index)
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('p', [_c('u', [_vm._v(_vm._s(_vm.joke.setup))])]), _vm._v(" "), _c('p', [_c('u', [_vm._v(_vm._s(_vm.joke.punchline))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ad2114e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Joke.vue
// module id = 13
// module chunks = 0